<div class="browser-compatibility">
  <div class="detail-wrapper">
    <div class="app-browser-card">
      <div class="app-browser-icon">
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_13074_60833" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="3" y="3" width="54"
            height="47">
            <path fill-rule="evenodd" clip-rule="evenodd"
              d="M3 49.9984L30 3.23438L57 49.9984H3ZM48.339 44.9974L30 13.2364L11.661 44.9974H48.339ZM32.502 21.6812H27.501V35.6822H32.502V21.6812ZM32.502 37.7073H27.501V42.7083H32.502V37.7073Z"
              fill="#282B3E" />
          </mask>
          <g mask="url(#mask0_13074_60833)">
            <rect width="60" height="60" fill="#282B3E" />
          </g>
        </svg>

      </div>

      <h2 class="app-browser-title">非対応ブラウザです</h2>

      <div class="app-browser-message">
        <p>「給付金らくらく請求」はSafariまたはGoogle Chromeでご利用いただく必要があります。</p>
      </div>

      <div class="app-browser-actions">

        <app-button class="copy-url-btn-wrapper" (click)="copyUrl()" [variant]="'secondary'" customClass="copy-url-btn">
          URLをコピー
        </app-button>

        <div class="app-browser-message">
          <p>上記のボタンを押して「給付金らくらく請求」のリンクをコピーし、Safari または Google Chrome に貼り付けてアクセスしてください。</p>
        </div>
      </div>
    </div>
  </div>
</div>